module.exports = __webpack_public_path__ + "static/media/icon-previous.227f7927.svg";